/**
 * Created by Jie Gao on 2021-02-22.
 */
import {TimelineLite, TimelineMax} from "gsap";
import {GGParsedInitData} from "../../server/data/GGParsedInitData";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";
import {DoubleBombSpinIntroView} from "./DoubleBombSpinIntroView";
import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {GGGameMode} from "../../gamemode/GGGameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";

export class DoubleBombSpinIntroController extends BeforeSpinStopPresentationController {
    protected _isRestoreDBSpin:boolean;
    protected _isDBSpin:boolean;
    protected _doubleBombSpins:number;
    protected _view:DoubleBombSpinIntroView;
    constructor(index:number) {
        super(index, "DoubleBombSpinIntroController");
        this._view = new DoubleBombSpinIntroView();
    }
    
    protected parseFeatureTriggered(data:GGParsedGameData):boolean {
        const gameData:GGParsedGameData = (<GGParsedGameData>data);
        this._isRestoreDBSpin = (data instanceof GGParsedInitData) ? (<GGParsedInitData>data).isBombSpinRestore : false;
        this._isDBSpin = gameData.wasFeatureBuy && (gameData.mode === GGGameMode.DOUBLE_BOMB) && (gameData.doubleBombSpins===2);
        this._doubleBombSpins = gameData.doubleBombSpins;
        return this._isDBSpin || this._isRestoreDBSpin;
    }

    protected getSpinStopDelay(data:GGParsedGameData):number {
        return 2.9;
    }

    protected startPresentation(timeline:TimelineMax):void {
        this._isRestoreDBSpin = false;
        this._view.show(timeline);
    }

    protected stopPresentation(isAborted:boolean):void {
        SlotGame.keypad.setZeroBetSpinCounter(this._doubleBombSpins);
        GGGameModuleConfig.fsCounter.showFlag("featureSign_x2bomb", this._doubleBombSpins);
        this._view.stopPresentation();
    }
}